import { createSlice } from '@reduxjs/toolkit';
import { openCreateCustomerAgentActionWizardAction, closeCreateCustomerAgentActionWizardAction } from 'forms-ai-lib/internal/actions/customerAgent';
const initialState = {
  isOpen: false,
  mode: 'CREATE'
};
export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    openModal: state => {
      state.isOpen = true;
    },
    closeModal: state => {
      state.isOpen = false;
    }
  },
  extraReducers: builder => {
    builder.addCase(openCreateCustomerAgentActionWizardAction, state => {
      state.mode = 'CUSTOMER_AGENT';
      state.isOpen = true;
    });
    builder.addCase(closeCreateCustomerAgentActionWizardAction, state => {
      state.mode = 'CREATE';
      state.isOpen = false;
    });
  }
});
export const {
  openModal,
  closeModal
} = configSlice.actions;